var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm._l(
        _vm.selectedTabName === _vm.brand ? _vm.filteredTrayData : _vm.TrayData,
        function(card, index) {
          return _c(
            "div",
            {
              key: card.title,
              staticClass: "board-card p-0",
              class: _vm.layoutToRenderIsSmall
                ? "small-list--my-tray"
                : "large-list--my-tray"
            },
            [
              _c("div", { staticClass: "card border-0 card" }, [
                _c("div", { staticClass: "card-body p-0" }, [
                  _vm.selectedTabName.toLowerCase() != _vm.shared.toLowerCase()
                    ? _c(
                        "div",
                        {
                          staticClass: "col-12 d-flex justify-content-end pr-0"
                        },
                        [
                          _c("div", { staticClass: "custom-control" }, [
                            _c("input", {
                              staticClass: "custom-control-input",
                              attrs: {
                                type: "checkbox",
                                id: "board-card" + index
                              },
                              on: {
                                click: function($event) {
                                  return _vm.projectSelected(card.id)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", {
                              staticClass: "custom-control-label",
                              attrs: { for: "board-card" + index }
                            })
                          ]),
                          _vm._v(" "),
                          _vm.selectedTabName !== _vm.archived
                            ? _c(
                                "div",
                                { staticClass: "btn-group" },
                                [
                                  _c("pc-dropdown-action", {
                                    attrs: {
                                      card: card,
                                      selectedProjectId: _vm.selectedProjectId,
                                      isAdminMode: _vm.isAdminMode
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "image-grid-wrapp-mt-tray" }, [
                    _c(
                      "div",
                      {
                        class: _vm.layoutToRenderIsSmall
                          ? "image-grid-my-tray-small"
                          : "image-grid-my-tray-large"
                      },
                      [
                        _c(
                          "picture",
                          {
                            staticClass: "w-100 position-relative d-block h-100"
                          },
                          [
                            card.coverPhoto
                              ? _c("img", {
                                  staticClass: "my-tray-thumnial-image h-100",
                                  class: _vm.layoutToRenderIsSmall
                                    ? "my-tray-image-small"
                                    : "my-tray-image-large",
                                  attrs: {
                                    src: card.coverPhoto,
                                    alt: card.title || ""
                                  }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.selectedTabName === _vm.brand && _vm.isAdminMode
                          ? _c(
                              "div",
                              { staticClass: "top-left-publish-unpublish" },
                              [
                                _c("span", { staticClass: "font-16" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        card.brandBoardStatus === 0
                                          ? _vm.$resourceString[
                                              "common.accounts.Unpublished.Msg"
                                            ]
                                          : card.brandBoardStatus === 1
                                          ? _vm.$resourceString[
                                              "common.accounts.Draft.Msg"
                                            ]
                                          : _vm.$resourceString[
                                              "common.accounts.Published.Msg"
                                            ]
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "on-hover-background-card" }, [
                      _c(
                        "a",
                        {
                          ref: "goToEditTray",
                          refInFor: true,
                          staticClass:
                            "btn btn-outline-white-warn btn btn-outline-primary",
                          attrs: {
                            href: "/Project/Edit/" + card.id,
                            rel: "noopener"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$resourceString[
                                "myProject.Project.GoToProject.Msg"
                              ]
                            )
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 pl-0" }, [
                    _c("div", {}, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "card-title text-size-normal black text-decoration-none my-2 card-title-myProject project-title",
                          attrs: { href: "/Project/Edit/" + card.id }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(card.title) +
                              "\n            "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {}, [
                      _c("span", { staticClass: "card-createdAt-MyProject" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              new Date(card.createdAt).toLocaleDateString(
                                "en-US",
                                {
                                  day: "numeric",
                                  month: "numeric",
                                  year: "2-digit"
                                }
                              )
                            )
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ]
          )
        }
      ),
      _vm._v(" "),
      _vm.TrayData.length == 0 && !_vm.showLoadMore
        ? _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "text-center mt-4" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$resourceString["common.NoDataAvailable.Msg"])
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }